export { default } from './RichTextRequiredAsterisk';
